import { render, staticRenderFns } from "./landingPage.vue?vue&type=template&id=2daa7ebe&"
import script from "./landingPage.vue?vue&type=script&lang=js&"
export * from "./landingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports